import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AsHttpParams } from '@models/AsHttpParams.model';
import { ICategoriesResponse } from '@models/categories.model';
import { GetAllDepartmentsResponse, GetDepartmentResponse, IDepartmentsResponse } from '@models/departments.model';
import { Observable, firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  private URL: string = environment.rootUrl;
  public store_id: any;

  private defaultStore = environment.defaultStore;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: string
  ) { }

  public getDepartments(store_id: string): Observable<IDepartmentsResponse> {
    if (isPlatformBrowser(this.platformId)) {
      this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store;
    }
    return this.http.get<IDepartmentsResponse>(`${this.URL}/departments/web?branch=${store_id}`);
  }

  public getCategories(department_id: string): Promise<ICategoriesResponse> {
    if (isPlatformBrowser(this.platformId)) {
      this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store;
    }
    return firstValueFrom(this.http.get<ICategoriesResponse>(`${this.URL}/departments/${department_id}/categories?branch_id=${this.store_id ?? this.defaultStore}`));
  }

  public getAllDepartments(store_id: string): Observable<GetAllDepartmentsResponse> {
    if (isPlatformBrowser(this.platformId)) {
      this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store;
    }
    return this.http.get<GetAllDepartmentsResponse>(`${this.URL}/departments?branch=${store_id}`);
  }

  public getDepartamentInfo(params?: AsHttpParams): Observable<GetDepartmentResponse> {
    if (isPlatformBrowser(this.platformId)) {
      this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store ?? this.defaultStore;
    }
    return this.http.get<GetDepartmentResponse>(`${this.URL}/ms-products/departments/${this.store_id}`, { params: params ?? {} });//todorevisar departamento
  }
}
